import { useState } from 'react';
import { Link } from 'react-router';
import './css/index.css';
import './css/font-awesome/font-awesome.css';
import './css/bootstrap2.css';
import './css/aos/aos.css';
import './css/swiper/swiper.css';
import './css/lightgallery.min.css';
import './css/style5.css';
import './css/responsive2.css';
import { lng } from './js/language.js';
import logo from './images/logov.png';
import enFlag from './images/en.svg';
import bgFlag from './images/bg.svg';

// function getDate() {
//   const today = new Date();
//   const month = today.getMonth() + 1;
//   const year = today.getFullYear();
//   const date = today.getDate();
//   return `${date}/${month}/${year}`;
// }

function Head() {

    const [langFlag, setLangFlag] = useState(localStorage.getItem('currentLang') === 'bg' || !localStorage.getItem('currentLang') ? enFlag : bgFlag);
    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);

    function changeLng() {
        localStorage.setItem('currentLang', langFlag === enFlag ? 'en' : 'bg');
        setCurrentLangObj(langFlag === enFlag ? lng.en : lng.bg);
        setLangFlag(langFlag === enFlag ? bgFlag : enFlag);
    }

    return (
        <>
            <header className="position-absolute w-100">
                {/* Navigation */}
                <div className="container">
                    <div className="top-header  d-sm-flex justify-content-between align-items-center">
                        <nav className="aic">
                            <ul className="nav social d-md-flex">
                                <li>
                                    <Link to="tel:+359887612233" title="+359887612233">
                                        <i className="fa fa-phone" aria-hidden="true"></i>
                                    </Link>      
                                </li>
                                <li>
                                    <Link to="mailto:admin@vekota.bg" title="admin@vekota.bg">
                                        <i className="fa fa-envelope" aria-hidden="true"></i>
                                    </Link>   
                                </li>
                                <li>
                                    <Link to="https://www.facebook.com/profile.php?id=61579028421219" target="_blank">
                                        <i className="fa fa-facebook" aria-hidden="true"></i>
                                    </Link>         
                                </li>
                                <li>
                                    <Link to="https://www.instagram.com/vekotasoft/" target="_blank">
                                        <i className="fa fa-instagram" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                        <Link to="/" className="navbar-brand">
                            <img src={logo} alt="Векота" />
                        </Link>
                        <nav className="navbar navbar-expand-md navbar-light">
                            <div className="justify-content-end" id="">
                                <ul className="navbar-nav">
                                    <li> 
                                        <Link to="/#about-us" className="nav-link about-us-head">
                                            {currentLangObj.aboutUs}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/#prices" className="nav-link prices">
                                            {currentLangObj.prices}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/blog" className="nav-link blog-nav">
                                            {currentLangObj.blog}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/#contacts" className="nav-link contacts">
                                            {currentLangObj.contacts}
                                        </Link>
                                    </li>
                                </ul>

                            </div>
                        </nav>
        
                        <div className="langdropdown" onClick={changeLng}>
                            <img src={langFlag} alt="EN" />
                            <span className="tooltiptext">
                                {currentLangObj.tooltipText}
                            </span>
                        </div>

                    </div>
                </div>
            </header>
            {/* {getDate()} */}
        </>
    );
}

export default Head;
